import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import CardIcon from '../../../../../assets/icons/card.svg';
import {Currency, getPriceString} from '../../../../../utils/money';

export const getData = (
  _event: NotificationEvent,
  context: EventContextsMap,
): EventData => {
  const {actor, course, membership} = context;
  const requestedRefund = membership?.requested_refund ?? 0;
  const currency = course?.edition?.payment_plan
    ? Currency[course.edition?.payment_plan.currency]
    : Currency.USD;

  return {
    avatar: actor?.avatar,
    avatarPlaceholder: actor?.name,
    buttons: [
      {
        disabled: true,
        id: 'refund_button',
        label: i18n.t('shared:refund'),
      },
      {
        id: 'contact_client_button',
        label: i18n.t('shared:contact_client'),
        scheme: 'gray',
      },
    ],
    icon: CardIcon,
    iconGradient: 'danger',
    title: i18n.t('notifications:refund_requested.title', {
      amount: getPriceString({
        currency,
        intZeroPrice: true,
        price: requestedRefund,
      }),
      clientName: actor?.name,
    }),
  };
};
